'use strict';

import { view } from '@/functions';

const prefix = '/commercialpartners';
export default [
    {
        path: `${prefix}`,
        name: 'commercialpartners',
        meta: {
            title: 'Partners',
            scopes: ['read_accounts', 'write_accounts']
        },
        component: () => view('commercialpartners/index'),
    },
];